export default "__VITE_ASSET__CSoWaVdm__"